import React from 'react';
import styled from 'styled-components';

import ShieldIconSvg from '../assets/hotels/home/shield.svg';

const ShieldIcon = styled(ShieldIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  fill: ${props => props.fill || props.theme.colors.green.base};
  height: 1.2rem;
  width: 1.2rem;
`;

export default ShieldIcon;
